// Environment Configuration

const isProduction = (): boolean => {
  return (
    window.location.hostname === 'verhinderungspflege.flexxi.care' ||
    window.location.hostname === 'www.verhinderungspflege.flexxi.care'
  );
};

export const config = {
  apiUrl: isProduction() ? 'https://api.flexxi.care/' : 'https://api.dev.flexxi.care/',

  stripeKey: isProduction()
    ? 'pk_live_WNFteFfeZYrWAzQGceSSmDXD'
    : 'pk_test_Uy4a9tomQRukBXm14a5VfgME',

  gtmId: 'GTM-5HH7TDV',

  isProduction: isProduction(),
};

// ============================================================
// DEVELOPMENT MODE SETTINGS
// Toggle features for development/debugging purposes
// ============================================================
export const devConfig = {
  // Master switch for dev mode (false in production)
  enabled: !isProduction(),
  
  // Show visual indicators on questions that affect the flow
  // (questions where the answer causes skips, resets, or flow stops)
  showConditionalFlowIndicators: !isProduction() && true, // Set to false to disable
  
  // Show wrench icon on recently fixed questions (for testing)
  showFixedQuestionIndicators: !isProduction() && true, // Set to false to disable
  
  // Log quiz state changes to console
  enableQuizStateLogging: !isProduction() && false,
};

export default config;

